/**
 * API клієнт для ref.loyalty_settings (Порція Роздріб.2/5a).
 * Backend: /api/v1/retail/loyalty-settings. Permissions: retail.loyalty_settings.manage.
 * One-active-per-organization (partial UNIQUE INDEX).
 */
import { api } from './client';
import type { Page } from './catalogs';

export interface LoyaltySettings {
  id: string;
  organization_id: string;
  accrual_percent: string;
  max_writeoff_percent: string;
  bonus_to_currency_rate: string;
  min_purchase_for_accrual: string;
  is_active: boolean;
  deletion_mark: boolean;
  created_at: string;
  created_by: string | null;
  comment: string | null;
}

export interface LoyaltySettingsCreate {
  organization_id: string;
  accrual_percent?: string;
  max_writeoff_percent?: string;
  bonus_to_currency_rate?: string;
  min_purchase_for_accrual?: string;
  is_active?: boolean;
  comment?: string | null;
}

export type LoyaltySettingsUpdate = Partial<Omit<LoyaltySettingsCreate, 'organization_id'>>;

export const retailLoyaltySettings = {
  list: (params?: { organization_id?: string; is_active?: boolean; limit?: number; offset?: number }) =>
    api.get<Page<LoyaltySettings>>('/retail/loyalty-settings', { params }).then((r) => r.data),
  get: (id: string) => api.get<LoyaltySettings>(`/retail/loyalty-settings/${id}`).then((r) => r.data),
  create: (payload: LoyaltySettingsCreate) =>
    api.post<LoyaltySettings>('/retail/loyalty-settings', payload).then((r) => r.data),
  update: (id: string, payload: LoyaltySettingsUpdate) =>
    api.patch<LoyaltySettings>(`/retail/loyalty-settings/${id}`, payload).then((r) => r.data),
  remove: (id: string) => api.delete(`/retail/loyalty-settings/${id}`).then(() => undefined),
};
